module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45135fc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/wrapper.vue
// module id = 565
// module chunks = 221